import { Component, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-confirm-downgrade-permission',
  templateUrl: './confirm-downgrade-permission.component.html',
  styleUrls: ['./confirm-downgrade-permission.component.scss'],
  imports: [CardComponent, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class ConfirmDowngradePermissionComponent implements OnInit {
  text: string;
  result: { confirm: boolean };
  dialogRef = inject(MatDialogRef<ConfirmDowngradePermissionComponent>);
  data: { name: string; ids?: number[]; itemLabel?: string } = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    const idList = this.getIdList();
    this.text = `Are you sure you want to downgrade your own permission to ${this.data.name}${idList}? You won't be able to upgrade your permission again!`;
  }

  private getIdList(): string {
    const { ids, itemLabel } = this.data;
    if (!ids?.length) return '';
    const label = itemLabel ?? 'item';
    const countedLabel = ids.length === 1 ? label : `${label}s`;
    return ` for the following ${countedLabel} (ID${ids.length === 1 ? '' : 's'}: ${ids.join(', ')})`;
  }

  cancel() {
    this.dialogRef.close({ confirm: false });
  }

  confirm() {
    this.dialogRef.close({ confirm: true });
  }
}
